import { Button } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";

type PlateNotValidProps = {
  plate: string;
};

export function PlateNotValid({ context, id, innerProps: { plate } }: ContextModalProps<PlateNotValidProps>) {
  const dismiss = () => {
    context.closeModal(id);
  };

  return (
    <>
      <div className="flex flex-col items-center justify-center gap-3 p-2 md:p-3">
        <h1 className="text-primary text-center text-2xl font-medium uppercase">A placa informada não corresponde a um caminhão!</h1>

        <a target="_blank" rel="noopener noreferrer" href={`https://www.fipeplaca.com.br/placa/${plate}`} className="text-center font-medium hover:underline">
          Clique aqui para saber mais
        </a>
      </div>

      <Button color="red" fullWidth onClick={dismiss}>
        Fechar
      </Button>
    </>
  );
}
